import React from "react";
import { StaffSideMenu } from "./StaffSideMenu";

export const StaffDashboard = () => {
  return (
    <div className="flex h-screen">
      <StaffSideMenu />

      {/* Main Content */}
      <div className="flex-1 p-6 bg-gray-100 pt-16"> {/* Add padding-top for mobile */}
        <h1 className="text-2xl font-bold">Welcome to the Staff Dashboard</h1>
        <p className="mt-4 text-gray-700">
          This is where you can manage staff and perform other administrative
          tasks.
        </p>
      </div>
    </div>
  );
};
